import { useEffect, useRef, useState } from "react";
import slider1 from "../static files/images/1.jpg";
import slider2 from "../static files/images/2.jpg";
import slider3 from "../static files/images/3.jpg";
import a1 from "../static files/images/a1.png";
import a2 from "../static files/images/a2.png";
import a3 from "../static files/images/a3.png";
import a4 from "../static files/images/a4.webp";
import a5 from "../static files/images/a5.png";
import a6 from "../static files/images/Temperli_Image-removebg-preview.png";
import rush from "../static files/images/rush.png";
import rushWhite from "../static files/images/rush White.png";
import sliding from "../static files/images/sliding-doors.png";
import slidingWhite from "../static files/images/sliding-doors White.png";
import security from "../static files/images/security.png";
import securityWhite from "../static files/images/security White.png";
import frame from "../static files/images/Frame.png";
import frameWhite from "../static files/images/Frame White.png";
import floor from "../static files/images/Floor.png";
import floorWhite from "../static files/images/Floor White.png";
import energy from "../static files/images/energy.png";
import energyWhite from "../static files/images/energy White.png";
import employee from "../static files/images/employee.png";
import employeeWhite from "../static files/images/employee White.png";
import creativity from "../static files/images/creativity.png";
import creativityWhite from "../static files/images/creativity White.png";
import business from "../static files/images/business.png";
import businessWhite from "../static files/images/business White.png";
import rightArrow from "../static files/images/right-arrow.png";
import portfolio from "../static files/images/CRL-Post-Railing-System3-e1709847838603.webp";
import heroimg1 from "../static files/images/hero images/image.png";
import heroimg2 from "../static files/images/hero images/2.webp";
import heroimg3 from "../static files/images/hero images/3.jpg";
import heroimg4 from "../static files/images/hero images/4.jpg";
import arrow from "../static files/images/right-arrow.png";
import besetka from "../static files/images/header images/Metal besetkalar.png";
import meheccer from "../static files/images/header images/Metal məhəccər.png";
import susemeheccer from "../static files/images/header images/Şüşə məhəccər.png";
import perqola from "../static files/images/header images/Tent perqola.png";
import tokmealiminum from "../static files/images/header images/Tökmə alüminium.png";
import qisbagcasi from "../static files/images/header images/qisbagcalari.png";
import avtomatikqapilar from "../static files/images/header images/avtomatikqapilar.png";
import alimizo from "../static files/images/header images/Alüminium izosistem.png";
import hebe from "../static files/images/header images/Hebe Schiebe.png";
import "../static files/styles/pages.css";
import Card from "../components/featuresCard";
import ExampleCard from "../components/examplesCard";
import { useDispatch, useSelector } from "react-redux";
import WhatsAppButton from "../components/whatsappButton";
import MyScroll from "../components/myScroll";
import { getPortfolioById, getPortfolios } from "../slices/portfolioReducer";
import { getBlogs } from "../slices/blogReducer";
import { useNavigate } from "react-router-dom";
import Loading from "../components/Loading";
import NotFound from "./Notfound";
import { userProductShow } from "../slices/productReducer";

const Home = () => {
  const slides = [
    {
      image: heroimg1,
      title: "Müasir Məkanlar üçün Rahat Söhbətgah Sistemləri",
      subtitle: "İstirahət və rahatlıq bəxş edən müasir söhbətgah.",
    },
    {
      image: heroimg2,
      title: "Estetik Bağ Perqolaları ilə Yeni Hisslər",
      subtitle: "Estetik və funksional dizaynlı müasir bağ perqolalar.",
    },
    {
      image: heroimg3,
      title: "Loft Üslubunda Şüşə və Metal Pilləkənlər",
      subtitle: "Loft üslubunda şüşə və metal pilləkən dizaynı.",
    },
    {
      image: heroimg4,
      title: "Panoramik Şüşə Balkonlarla Maksimum Rahatlıq",
      subtitle: "Panoramik görüntü və rahatlığı birləşdirən şüşə balkonlar.",
    },
  ];

  const cards = [
    {
      image: floor,
      imageWhite: floorWhite,
      title: "Yüksək Keyfiyyətli Materiallar",
      content: `Layihələrimizdə yalnız beynəlxalq standartlara cavab verən şüşə və alüminium məhsullarından istifadə
  edirik. Bu yanaşma həm uzunömürlülük, həm də keyfiyyət baxımından müştərilərimizə maksimum etibar
  verir. Materialların davamlılığı sayəsində sistemlərimiz illərlə öz formasını və funksionallığını qoruyur`,
    },
    {
      image: frame,
      imageWhite: frameWhite,
      title: "Müasir Dizayn Həlləri",
      content: `Azglass Design Group Construction, şüşə və alüminium konstruksiyalarda müasir memarlıq tələblərinə
  uyğun həllər təqdim edir. İstər fasad, istər məhəccər, istərsə də interyer arakəsmələr olsun, bütün
  layihələrimizdə sadəliyi, estetikliyi və funksionallığı birləşdirərək məkanlara müasir və dəyərli görünüş
  qazandırırıq.`,
    },
    {
      image: energy,
      imageWhite: energyWhite,
      title: "Enerji Səmərəliliyi",
      content: `Azglass sistemlərində istifadə olunan xüsusi izolyasiya şüşələri və konstruksiya həlləri, istilik və səs itkisini
  minimuma endirir. Bu isə həm enerjiyə qənaət, həm də yaşayış və iş məkanlarında daha komfortlu şərait
  deməkdir. Əlavə olaraq, bu yanaşma müştərilərin enerji xərclərinin azalmasına kömək edir.`,
    },
    {
      image: security,
      imageWhite: securityWhite,
      title: "Maksimum Təhlükəsizlik",
      content: `Məkanların təhlükəsizliyi bizim üçün əsas prioritetlərdəndir. İstifadə etdiyimiz möhkəm şüşələr, xüsusi
  bərkidici detallar və davamlı alüminium profillər, həm interyer, həm də eksteryer layihələrində güvənli və
  etibarlı sistemlər qurmağımıza imkan verir.
  `,
    },
    {
      image: business,
      imageWhite: businessWhite,
      title: "Çoxfunksiyalı Sistemlər",
      content: `Azglass yalnız ənənəvi həllərlə kifayətlənmir. Gilyotin sistemləri, sürmə şüşələr, avtomatik açılıb-bağlanan
  mexanizmlər və innovativ konstruksiya seçimləri ilə müştərilərimizə həm rahatlıq, həm də fərqli
  funksionallıq təqdim edirik. Bu sistemlər həm məkan istifadəsini optimallaşdırır, həm də estetik görünüş
  yaradır.`,
    },
    {
      image: employee,
      imageWhite: employeeWhite,
      title: "Sürətli və Peşəkar Quraşdırma",
      content: `Peşəkar ustalardan ibarət komandamız layihələrin quraşdırılmasını yüksək dəqiqlik və vaxtında həyata
  keçirir. Müştərilərimiz heç bir əlavə narahatlıq yaşamadan qısa müddətdə hazır və istifadəyə tam yararlı
  sistemlər əldə edirlər.`,
    },
    {
      image: creativity,
      imageWhite: creativityWhite,
      title: "Dizayna Uyğun Fərdiləşdirmə",
      content: `Hər müştərinin tələbi fərqlidir, biz də bu fərqliliyi nəzərə alaraq individual dizayn və ölçü seçimləri təqdim
  edirik. İstənilən rəng, forma və modeldə hazırlanan sistemlər sayəsində məkanlar müştərinin arzularına
  uyğun şəkildə fərdiləşdirilir.`,
    },
    {
      image: rush,
      imageWhite: rushWhite,
      title: "Uzunmüddətli Zəmanət",
      content: `Azglass tərəfindən quraşdırılan bütün məhsul və sistemlər zəmanətlə təmin edilir. Bu yanaşma
  müştərilərimizə xidmətimizin davamlı olduğuna, keyfiyyət və etibarlılığımıza güvənməyə şərait yaradır.`,
    },
    {
      image: sliding,
      imageWhite: slidingWhite,
      title: "Tam Şüşə Həlləri",
      content: `Biz yalnız bir sahəyə fokuslanmırıq, müştərilərimizə bütün şüşə ilə bağlı kompleks həllər təqdim edirik.
  Fasad sistemlərindən tutmuş balkon və məhəccərlərə, sürmə sistemlərindən interyer arakəsmələrinə
  qədər hər şeyi vahid xidmət olaraq təklif edirik. Bu isə müştərilərə rahatlıq və bütün işlərin bir ünvanda
  həll olunması üstünlüyünü verir.`,
    },
  ];

  const categories = [
    {
      id: 1,
      name: "Pəncərə sistemləri",
      subcategories: [
        { name: "Veka pəncərələri", slug: "veka-pencereleri" },
        { name: "Alüminium izosistem", slug: "aluminium-izosistem" },
        { name: "Hebe Schiebe", slug: "hebe-schiebe" },
        { name: "Taxta pəncərələr", slug: "taxta-pencereler" },
        { name: "Şəbəkə (Karolaj)", slug: "sebeke-karolaj" },
        { name: "Giyotin pəncərələr", slug: "giyotin-pencereler" },
      ],
    },
    {
      id: 2,
      name: "Metal Konstruksiya",
      subcategories: [
        { name: "Anbarlar", slug: "anbarlar" },
        { name: "Metal söhbətgah", slug: "metal-sohbetgah" },
        { name: "Pilləkən", slug: "pilleken" },
        { name: "Məhəccər", slug: "meheccer" },
        { name: "Loft Soft", slug: "loft-soft" },
        { name: "Avtomatik qapılar", slug: "avtomatik-qapilar" },
      ],
    },
    {
      id: 3,
      name: "Fasad sistemləri",
      subcategories: [
        { name: "Şüşə fasad (cəbhə)", slug: "suse-fasad-cebhe" },
        {
          name: "Alüminium kompozit panel (Alkopon)",
          slug: "aluminium-kompozit-panel-alkopon",
        },
      ],
    },
    {
      id: 4,
      name: "Məhəccər",
      subcategories: [
        { name: "Tökmə alüminium", slug: "tokme-aluminium" },
        { name: "Şüşə məhəccər", slug: "suse-meheccer" },
        { name: "Metal məhəccər", slug: "metal-meheccer" },
      ],
    },
    {
      id: 5,
      name: "Digər",
      subcategories: [
        { name: "Tent-perqola", slug: "tent-perqola" },
        { name: "İzolyasiya sistemləri", slug: "izolasiya-sistemleri" },
        { name: "Ağcaqanad torları", slug: "agcaqanad-torlari" },
        { name: "Cambalkon", slug: "cambalkon" },
        { name: "Qış bağçaları", slug: "qis-bagcalari" },
      ],
    },
  ];

  const cardRef = useRef(null);
  const categoryCardRef = useRef(null);

  const { product, status, error } = useSelector((state) => state.products);
  const { portfolios } = useSelector((state) => state.portfolio);
  const { blogs } = useSelector((state) => state.blogs);
  const [current, setCurrent] = useState(0);
  const [open, setOpen] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);
  const [prev, setPrev] = useState(0);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getPortfolios());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getBlogs());
    console.log(blogs);
  }, [dispatch]);

  const nextSlide = () => {
    setPrev(current);
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const prevSlideHandler = () => {
    setPrev(current);
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  //Hero slide
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide(); // hər 4 saniyədən bir slide dəyişir
    }, 4000);

    return () => clearInterval(interval); // komponent unmount olduqda intervali təmizləyir
  }, []);

  //Portfolio slide
  useEffect(() => {
    const slider = document.querySelector(".portfolio-section .cards");
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });

    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
    });

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1; // scroll sürəti
      slider.scrollLeft = scrollLeft - walk;
    });
  }, []);

  function stringToSlug(str) {
    return str
      .toLowerCase() // Kiçik hərflərə çevir
      .trim() // Baş və sondakı boşluqları sil
      .replace(/[\s\W-]+/g, "-") // Boşluqları və xüsusi simvolları '-' ilə əvəz et
      .replace(/^-+|-+$/g, ""); // Baş və sondakı '-'ləri sil
  }

  const handleSubcategoryClick = async (subcategory) => {
    // dispatch thunk ilə API-dan məlumat al
    await dispatch(userProductShow(subcategory));
    // details səhifəsinə yönləndir
    navigate(`/details/${subcategory}`);
  };

  if (status === "loading") {
    return <Loading />;
  }
  const scrollAmount = 300; // hər klikdə 300px sola/sağa gedəcək, lazım gələrsə dəyiş

  const scrollRight = () => {
    if (cardRef.current) {
      cardRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  const scrollLeft = () => {
    if (cardRef.current) {
      cardRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    }
  };

  const scrollRightCat = () => {
    if (categoryCardRef.current) {
      categoryCardRef.current.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const scrollLeftCat = () => {
    if (categoryCardRef.current) {
      categoryCardRef.current.scrollBy({
        left: -scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <main>
      <WhatsAppButton />
      <section className="hero">
        <div
          className="hero-bg-wrapper"
          style={{
            transform: `translateX(-${current * 100}%)`,
          }}
        >
          {slides.map((slide, index) => (
            <div
              key={index}
              className="hero-bg-slide"
              style={{
                backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${slide.image})`,
              }}
            ></div>
          ))}
        </div>

        <div className="hero-overlay">
          <h4>{slides[current].subtitle}</h4>
          <h1>{slides[current].title}</h1>
          <button
            className="hero-btn"
            onClick={() => {
              window.scrollTo({
                top: window.scrollY + 1550, // neçə px aşağı getsin
                behavior: "smooth",
              });
            }}
          >
            Layihələrimiz
          </button>
        </div>

        <div className="hero-indicators">
          <div className="left-arrow-box" onClick={prevSlideHandler}>
            <div className="img-box">
              <img src={rightArrow} alt="arrow" />
            </div>
          </div>
          <ul>
            {slides.map((slide, index) => (
              <li
                key={index}
                onClick={() => setCurrent(index)}
                className={current === index ? "active" : ""}
              >
                <article className="card">
                  <a
                    className="comp-a"
                    style={{
                      color: current === index ? "#157BC6" : "white",
                      transition: "0.3s",
                      cursor: "pointer",
                      fontSize: "0.700vw",
                      fontWeight: "bold",
                    }}
                  >
                    {slide.subtitle}
                  </a>
                  <a
                    className="mobile-a"
                    style={{
                      color: current === index ? "#157BC6" : "white",
                      transition: "0.3s",
                      cursor: "pointer",
                      fontSize: "2vw",
                      fontWeight: "bold",
                    }}
                  >
                    {slide.subtitle}
                  </a>
                </article>
              </li>
            ))}
          </ul>
          {/* <ul>
            {slides.map((slide, index) => (
              <li key={index} onClick={() => setCurrent(index)}>
                <article className="card">
                  <a
                    className="comp-a"
                    style={{
                      color: current === index ? "#157BC6" : "white",
                      transition: "0.3s",
                      cursor: "pointer",
                      fontSize: "0.700vw",
                      fontWeight: "bold",
                    }}
                  >
                    {slide.subtitle}
                  </a>
                  <a
                    className="mobile-a"
                    style={{
                      color: current === index ? "#157BC6" : "white",
                      transition: "0.3s",
                      cursor: "pointer",
                      fontSize: "1.563vw",
                      fontWeight: "bold",
                    }}
                  >
                    {slide.subtitle}
                  </a>
                </article>
              </li>
            ))}
          </ul> */}

          <div className="right-arrow-box" onClick={nextSlide}>
            <div className="img-box">
              <img src={rightArrow} alt="arrow" />
            </div>
          </div>
        </div>
      </section>

      <section className="product-section">
        <p className="header">
          Keyfiyyətli və innovativ məhsullarımızı kəşf edin
        </p>

        <div className="arrows">
          <img
            className="left-arrow"
            src={arrow}
            alt="left-arrow"
            onClick={scrollLeftCat}
            style={{ cursor: "pointer" }}
          />
          <img
            className="right-arrow"
            src={arrow}
            alt="right-arrow"
            onClick={scrollRightCat}
            style={{ cursor: "pointer" }}
          />
        </div>
        <ul className="cards" ref={categoryCardRef}>
          <li>
            <article className="card">
              <h2>Metal Söhbətgahlar</h2>
              <h3>Möhkəm və zərif metal söhbətgah.</h3>
              <img src={besetka} alt="surme sistemleri" />
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubcategoryClick("metal-sohbetgah");
                }}
              >
                Ətraflı məlumat
              </a>
            </article>
          </li>
          <li>
            <article className="card">
              <h2>Şüşə Məhəccərlər</h2>
              <h3>Modern və şəffaf şüşə məhəccər.</h3>
              <img src={susemeheccer} alt="surme sistemleri" />
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubcategoryClick("suse-meheccer");
                }}
              >
                Ətraflı məlumat
              </a>
            </article>
          </li>
          <li>
            <article className="card">
              <h2>Tökmə Aluminiumlar</h2>
              <h3>Hava şəraitinə davamlı, möhkəm tent-perqola.</h3>
              <img src={tokmealiminum} alt="surme sistemleri" />
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubcategoryClick("tokme-aluminium");
                }}
              >
                Ətraflı məlumat
              </a>
            </article>
          </li>
          <li>
            <article className="card">
              <h2>Tent-Perqolalar</h2>
              <h3>Hava şəraitinə davamlı, möhkəm tent-perqola.</h3>
              <img src={perqola} alt="surme sistemleri" />
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubcategoryClick("tent-perqola");
                }}
              >
                Ətraflı məlumat
              </a>
            </article>
          </li>
          <li>
            <article className="card">
              <h2>Metal Məhəccərlər</h2>
              <h3>Sadeliyi və gücü ilə seçilən metal məhəccər.</h3>
              <img
                className="metal-meheccer-img"
                src={meheccer}
                alt="surme sistemleri"
              />
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubcategoryClick("metal-meheccer");
                }}
              >
                Ətraflı məlumat
              </a>
            </article>
          </li>
          <li>
            <article className="card">
              <h2>Alüminium İzosistemlər</h2>
              <h3>Sadə dizaynlı, uzunömürlü alüminium izosistem.</h3>
              <img src={alimizo} alt="surme sistemleri" />
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubcategoryClick("aluminium-izosistem");
                }}
              >
                Ətraflı məlumat
              </a>
            </article>
          </li>
          <li>
            <article className="card">
              <h2>Hebe Schiebe</h2>
              <h3>Geniş açıla bilən, möhkəm Hebe Schiebe sistemi.</h3>
              <img
                className="metal-meheccer-img"
                src={hebe}
                alt="surme sistemleri"
              />
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubcategoryClick("hebe-schiebe");
                }}
              >
                Ətraflı məlumat
              </a>
            </article>
          </li>
          <li>
            <article className="card">
              <h2>Avtomatik Qapılar</h2>
              <h3>Rahat və təhlükəsiz keçid təmin edən avtomatik qapılar.</h3>
              <img src={avtomatikqapilar} alt="avtomatik qapilar" />
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubcategoryClick("avtomatik-qapilar");
                }}
              >
                Ətraflı məlumat
              </a>
            </article>
          </li>
          <li>
            <article className="card">
              <h2>Qış Bağçaları</h2>
              <h3>Müasir və funksional qış bağçaları.</h3>
              <img src={qisbagcasi} alt="qis bagcalari" />
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubcategoryClick("qis-bagcalari");
                }}
              >
                Ətraflı məlumat
              </a>
            </article>
          </li>
        </ul>

        <div className="categories">
          <div className="circle"></div>
          <p>Evlər üçün həllər</p>
          <div className="line"></div>
          <ul>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubcategoryClick(categories[4].subcategories[1].slug);
                }}
              >
                {categories[4].subcategories[1].name}
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubcategoryClick(categories[4].subcategories[3].slug);
                }}
              >
                {categories[4].subcategories[3].name}
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubcategoryClick(categories[4].subcategories[2].slug);
                }}
              >
                {categories[4].subcategories[2].name}
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubcategoryClick(categories[0].subcategories[3].slug);
                }}
              >
                {categories[0].subcategories[3].name}
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubcategoryClick(categories[1].subcategories[3].slug);
                }}
              >
                {categories[1].subcategories[3].name}
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubcategoryClick(categories[0].subcategories[4].slug);
                }}
              >
                {categories[0].subcategories[4].name}
              </a>
            </li>
          </ul>
        </div>
      </section>

      <section className="portfolio-section">
        <div className="header">
          <div className="line-horizontal"></div>
          <div className="header-text">
            <div className="circle"></div>
            <h3>Görülən işlər</h3>
            <div className="line-vertical"></div>
          </div>
        </div>

        <div className="body">
          <div className="body-header">
            <h2>Portfoliomuz – hər bir quruluşda bir hekayə</h2>
            <div>
              <h3>
                Layihələrimizin hər biri innovasiya və dayanıqlı memarlığın bir
                hekayəsidir.
              </h3>
            </div>
          </div>

          <ul className="cards">
            {portfolios.map((portfolio) => {
              return (
                <li key={portfolio.id}>
                  <article
                    className="card"
                    onClick={() => {
                      dispatch(getPortfolioById(portfolio._id));
                      navigate(`/project/${portfolio._id}`);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      className="portfolio-image"
                      src={portfolio.image}
                      alt={portfolio.title}
                    />
                    <h4>{portfolio.title}</h4>
                    <img className="right-arrow" src={rightArrow} alt="arrow" />
                  </article>
                </li>
              );
            })}
          </ul>
        </div>
      </section>

      <section className="features-section">
        <div className="header">
          <div className="line-horizontal"></div>
          <div className="header-text">
            <div className="circle"></div>
            <h3>Xüsusiyyətlər</h3>
            <div className="line-vertical"></div>
          </div>
        </div>

        <div className="section-body">
          <div className="image-box">
            <h3>Bizi fərqləndirən nədir</h3>
            <img src={a6} alt="Tam şüşə həlləri" />
            <div className="contact-button">
              <div className="circle"></div>
              <p>Daha ətraflı məlumat üçün bizimlə əlaqə saxlayın.</p>
              <a href="#">Əlaqə</a>
            </div>
          </div>
          <ul className="cards">
            {cards.map((card, index) => (
              <li>
                <Card
                  image={card.image}
                  imageWhite={card.imageWhite}
                  title={card.title}
                  content={card.content}
                  isOpen={activeIndex === index}
                  onToggle={() => handleToggle(index)}
                />
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="examples-section">
        <div className="header">
          <div className="line-horizontal"></div>
          <div className="header-text">
            <div className="circle"></div>
            <h3>Nümunələr</h3>
            <div className="line-vertical"></div>
          </div>
        </div>

        <div className="body">
          <div className="body-header">
            <h2>Müştərilərimiz Üçün Hazırladığımız Praktik Məsləhətlər</h2>
            <h3>
              Şüşə və alüminium sistemləri haqqında maraqlı məlumatları buradan
              öyrənin.
            </h3>
          </div>

          <div className="arrows">
            <img
              className="left-arrow"
              src={arrow}
              alt="left-arrow"
              onClick={scrollLeft}
              style={{ cursor: "pointer" }}
            />
            <img
              className="right-arrow"
              src={arrow}
              alt="right-arrow"
              onClick={scrollRight}
              style={{ cursor: "pointer" }}
            />
          </div>
          <ul className="cards" ref={cardRef}>
            {blogs.map((blog) => {
              return (
                <li>
                  <ExampleCard blog={blog} />
                </li>
              );
            })}
          </ul>
        </div>
      </section>

      <section className="location-section">
        <h2>Ofisimizin xəritə üzərində məkanı</h2>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1659.649211303713!2d49.85986073375978!3d40.39249117023704!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307d152bd7d73b%3A0x92a47a0852f48752!2zOTUgUWFyYWJhxJ8ga8O8w6fJmXNpLCBCYWvEsQ!5e0!3m2!1saz!2saz!4v1758971556771!5m2!1saz!2saz"

          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </section>
    </main>
  );
};

export default Home;
